import apolloClient from 'api/apolloClient';
import { GET_CONFIGURABLE_EMAILS, SAVE_CONFIGURABLE_EMAILS_FOR_USER } from 'api/emailService';
import { ConfigurableEmailInfo, ConfigurableEmails } from 'types/emailService';

export async function getConfigurableEmails(): Promise<ConfigurableEmails> {
  const res = await apolloClient.query<{
    getConfigurableEmails: ConfigurableEmailInfo[];
    getConfigurableEmailsForUser: string[];
  }>({
    query: GET_CONFIGURABLE_EMAILS,
    fetchPolicy: 'no-cache',
  });
  return {
    emails: res.data.getConfigurableEmails,
    emailsForUser: res.data.getConfigurableEmailsForUser,
  };
}

export async function saveConfigurableEmailsForUser(emailTypes: string[]): Promise<boolean> {
  const { data } = await apolloClient.mutate<{ saveConfigurableEmailsForUser: boolean }>({
    mutation: SAVE_CONFIGURABLE_EMAILS_FOR_USER,
    variables: { emailTypes },
  });
  return data?.saveConfigurableEmailsForUser || false;
}
